import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={27}
    height={32}
    viewBox="0 0 27 32"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      d="M13.65 23.212c-.68 0-1.37-.47-1.37-1.37 0-1.8 2.74-1.8 2.74 0 0 .9-.69 1.37-1.37 1.37Zm0-1.99c-.29 0-.62.16-.62.62 0 .46.33.62.62.62s.62-.16.62-.62c0-.46-.33-.62-.62-.62Z"
    />
    <Path
      fill={props.fill || '#444697'}
      d="M14.64 21.841c0 1.33-1.99 1.33-1.99 0s1.99-1.33 1.99 0Z"
    />
    <Path
      fill={props.fill || '#444697'}
      d="M5.69 31.17c-2.95 0-5.35-2.4-5.35-5.35v-7.96c0-2.95 2.4-5.35 5.35-5.35h.62v-4.6C6.31 3.86 9.6.57 13.65.57s7.34 3.29 7.34 7.34v4.6h.62c2.95 0 5.35 2.4 5.35 5.35v7.96c0 2.95-2.4 5.35-5.35 5.35H5.69Zm0-15.91c-1.44 0-2.61 1.17-2.61 2.61v7.96c0 1.44 1.17 2.61 2.61 2.61h15.92c1.44 0 2.61-1.17 2.61-2.61v-7.96c0-1.44-1.17-2.61-2.61-2.61H5.69Zm12.56-2.74v-4.6a4.6 4.6 0 0 0-9.2 0v4.6h9.2Z"
    />
    <Path
      fill={props.fill || '#444697'}
      d="M21.61 12.89h-.99V7.92c0-3.84-3.12-6.96-6.96-6.96S6.7 4.08 6.7 7.92v4.97h-.99c-2.74 0-4.97 2.231-4.97 4.971v7.96c0 2.74 2.23 4.97 4.97 4.97h15.91c2.74 0 4.97-2.23 4.97-4.97v-7.96c0-2.74-2.23-4.97-4.97-4.97h-.01ZM8.68 7.92c0-2.74 2.23-4.97 4.97-4.97 2.74 0 4.97 2.23 4.97 4.97v4.97H8.67V7.92h.01Zm15.91 17.901a2.98 2.98 0 0 1-2.98 2.98H5.7c-1.65 0-2.98-1.34-2.98-2.98v-7.96c0-1.65 1.34-2.98 2.98-2.98h15.91c1.65 0 2.98 1.34 2.98 2.98v7.96Z"
    />
  </Svg>
);
export default SvgComponent;
